<h1 mat-dialog-title>{{ 'AI_ASSISTANT.SETTINGS.IMAGE_UPLOAD.CHANGE_APPEARANCE' | translate }}</h1>

<mat-dialog-content>
  @switch (state()) {
    @case ('view') {
      <div class="image-preview">
        <glxy-avatar [src]="data.imageURL" [svgIcon]="data.defaultSvg" [width]="220"></glxy-avatar>

        <div class="image-actions">
          <button mat-stroked-button (click)="state.set('change')">
            {{ 'AI_ASSISTANT.SETTINGS.IMAGE_UPLOAD.CHANGE' | translate }}
          </button>
          @if (data.imageURL) {
            <button mat-stroked-button (click)="onRemove()">
              {{ 'AI_ASSISTANT.SETTINGS.IMAGE_UPLOAD.REMOVE' | translate }}
            </button>
          }
        </div>
      </div>
    }
    @case ('change') {
      @if (!file()) {
        <div class="image-selection">
          <div class="library-section">
            <p class="library-title">{{ 'AI_ASSISTANT.SETTINGS.IMAGE_LIBRARY.TITLE' | translate }}</p>
            <p class="library-description">{{ 'AI_ASSISTANT.SETTINGS.IMAGE_LIBRARY.DESCRIPTION' | translate }}</p>
            <div class="library-grid">
              <button class="library-image-button upload-trigger" (click)="fileInput.click()" type="button">
                <div class="upload-circle">
                  <mat-icon>add_photo_alternate</mat-icon>
                </div>
              </button>
              <input
                #fileInput
                type="file"
                accept=".png,.jpg,.jpeg"
                (change)="onFileSelected($event)"
                hidden
              />
              @for (image of libraryImages; track image.filename) {
                <button class="library-image-button" (click)="selectLibraryImage(image.url)" type="button">
                  <glxy-avatar [src]="image.url" [width]="80"></glxy-avatar>
                </button>
              }
            </div>
          </div>
        </div>
      } @else {
        <glxy-image-editor
          [maxEditorHeight]="'300px'"
          [fileInfo]="file()!"
          [align]="'start'"
          [maxDimensions]="{ width: 400, height: 400 }"
          [aspectRatios]="[{ label: '1:1', value: 1, selected: true }]"
          (closed)="endEdit($event)"
          class="image-editor"
        />
      }
    }
  }
</mat-dialog-content>
